import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  loadNotificationIsRequesting: false,
  updateNotificationIsRequesting: false,
  mvpTrainingData: [],
  sessions: null,
  loadingSessions: false,
  loadingPackages: false,
  todayAndUpcomingsessions: [],
  userPackages: null,
  notification: [],
  updatedNotification: [],
  error: null,
  qrCodeDetails: {}
};

const request = (state = INITIAL_STATE) => {
  return { ...state, isRequesting: true, error: null };
};

const failure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    error,
  };
};

const loadSessionsRequest = (state = INITIAL_STATE) => {
  return { ...state, loadingSessions: true, error: null };
};

const loadSessionsFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingSessions: false,
    error,
  };
};

const loadPackagesRequest = (state = INITIAL_STATE) => {
  return { ...state, loadingPackages: true, error: null };
};

const loadPackagesFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadingPackages: false,
    error,
  };
};

const loadNotificationRequest = (state = INITIAL_STATE) => {
  return { ...state, loadNotificationIsRequesting: true, error: null };
};

const loadNotificationFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    loadNotificationIsRequesting: false,
    error,
  };
};

const updateNotificationRequest = (state = INITIAL_STATE) => {
  return { ...state, updateNotificationIsRequesting: true, error: null };
};

const updateNotificationFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    updateNotificationIsRequesting: false,
    error,
  };
};

const loadMvpTraningSuccess = (state = INITIAL_STATE, { mvpTrainingData }) => {
  return {
    ...state,
    mvpTrainingData,
    isRequesting: false,
  };
};

const loadSessionsNewSuccess = (state = INITIAL_STATE, { sessions }) => {
  return {
    ...state,
    sessions,
    loadingSessions: false,
  };
};

const loadUserPackagesSuccess = (state = INITIAL_STATE, { userPackages }) => {
  return {
    ...state,
    userPackages,
    loadingPackages: false,
  };
};

const loadNotificationSuccess = (state = INITIAL_STATE, { notification }) => {
  return {
    ...state,
    notification,
    loadNotificationIsRequesting: false,
  };
};

const updateNotificationSuccess = (state = INITIAL_STATE, { updatedNotification }) => {
  return {
    ...state,
    updatedNotification,
    updateNotificationIsRequesting: false,
  };
};

const loadQRCodeSuccess = (state = INITIAL_STATE, { qrCodeDetails }) => {
  return {
    ...state,
    qrCodeDetails,
    isRequesting: false,
  };
};

export const HANDLERS = {
  [Types.LOAD_MVP_TRAINING_REQUEST]: request,
  [Types.LOAD_MVP_TRAINING_SUCCESS]: loadMvpTraningSuccess,
  [Types.LOAD_MVP_TRAINING_FAILURE]: failure,

  [Types.LOAD_SESSIONS_NEW_REQUEST]: loadSessionsRequest,
  [Types.LOAD_SESSIONS_NEW_SUCCESS]: loadSessionsNewSuccess,
  [Types.LOAD_SESSIONS_NEW_FAILURE]: loadSessionsFailure,

  [Types.LOAD_USER_PACKAGES_REQUEST]: loadPackagesRequest,
  [Types.LOAD_USER_PACKAGES_SUCCESS]: loadUserPackagesSuccess,
  [Types.LOAD_USER_PACKAGES_FAILURE]: loadPackagesFailure,

  [Types.LOAD_NOTIFICATION_REQUEST]: loadNotificationRequest,
  [Types.LOAD_NOTIFICATION_SUCCESS]: loadNotificationSuccess,
  [Types.LOAD_NOTIFICATION_FAILURE]: loadNotificationFailure,

  [Types.UPDATE_NOTIFICATION_REQUEST]: updateNotificationRequest,
  [Types.UPDATE_NOTIFICATION_SUCCESS]: updateNotificationSuccess,
  [Types.UPDATE_NOTIFICATION_FAILURE]: updateNotificationFailure,

  [Types.LOAD_QR_CODE_REQUEST]: request,
  [Types.LOAD_QR_CODE_SUCCESS]: loadQRCodeSuccess,
  [Types.LOAD_QR_CODE_FAILURE]: failure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
